module.exports = __webpack_public_path__ + "assets/pdf/cycle3_investment_plan_epa.1aa21b9b.pdf";